import { render, staticRenderFns } from "./candidate-search-field.vue?vue&type=template&id=788bc96c&scoped=true&"
import script from "./candidate-search-field.vue?vue&type=script&lang=js&"
export * from "./candidate-search-field.vue?vue&type=script&lang=js&"
import style0 from "./candidate-search-field.vue?vue&type=style&index=0&id=788bc96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bc96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
